export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8850.4408760a.jpg";